import React, { useContext, useState } from 'react';
import { withStyles } from '@mui/styles';
import { observer } from 'mobx-react-lite';
import SkillsSelection from '../../common/SkillsSelection';
import SetsListWrapper from './SetsListWrapper';
import SelectedSet from './SelectedSet';
import { setLibraryCtx } from '../store';

const styles = theme => ({
    wrapper: {
        display: 'flex',
        position: 'relative',
        overflow: 'auto',
        minHeight: 400,
        width: '100%',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            display: 'block'
        }
    },
    leftPanel: {
        width: '50%',
        minHeight: 550,
        minWidth: 650,
        paddingBottom: 50,
        backgroundColor: theme.palette.grey[50],
        position: 'relative',
        padding: '16px 0',
        borderRight: `2px solid ${theme.palette.grey[300]}`,
        [theme.breakpoints.down('md')]: {
            width: '100%',
            borderRight: 'none',
            borderBottom: `2px solid ${theme.palette.grey[300]}`
        }
    },
    contentPanel: {
        width: '50%',
        position: 'relative',
        padding: '16px 0 40px',
        minWidth: 550,
        [theme.breakpoints.down('md')]: {
            width: '100%',
            padding: '26px 30px 40px'
        }
    }
});

const ContentSets = observer(({ classes, selectedSkill, setSelectedSkill, ...other }) => {
    const [addToSetQuestionUuid, setAddToSetQuestionUuid] = useState(null);
    const [removeFromQuestionUuid, setRemoveFromSetQuestionUuid] = useState(null);

    const store = useContext(setLibraryCtx);

    const additionalProps = {
        addToSetQuestionUuid,
        setAddToSetQuestionUuid,
        removeFromQuestionUuid,
        setRemoveFromSetQuestionUuid
    };

    const handleChangeSkill = (skill) => {
        setSelectedSkill(skill);
        store.setSelectedSkill(skill);
    };

    return (
        <div className={classes.wrapper}>
            <div className={classes.leftPanel}>
                <SkillsSelection
                    selectedSkill={selectedSkill}
                    setSelectedSkill={handleChangeSkill}
                />
                <SetsListWrapper {...other} {...additionalProps} />
            </div>
            <div className={classes.contentPanel}>
                <SelectedSet {...other} />
            </div>
        </div>
    );
});

export default withStyles(styles)(ContentSets);
